var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-toolbar',{attrs:{"light":""}},[_c('v-toolbar-title',[_c('h2',[_vm._v(_vm._s(this.$t('external_users_management')))])]),_c('v-spacer')],1),_c('dynamic-table',{attrs:{"dataset":_vm.externalUsers,"headers":_vm.headers,"module-name":"external_users"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }